(function () {
  var styleId = 'cyclowax-hide-gorgias-cancel-reply';
  var styleText = [
    '#conversation span:has(> button[aria-label*="Order Question"])',
    '#conversation span:has(> button[aria-label*="Cancel Order"])',
    '#conversation span:has(> button[aria-label*="Bestellung stornieren"])'
  ].join(', ') + ' { display: none !important; }';

  function addStyle() {
    var frame = document.querySelector('#gorgias-chat-container #chat-window');
    var frameDocument;

    try {
      frameDocument = frame && frame.contentDocument;
    } catch (error) {
      return false;
    }

    if (!frameDocument || !frameDocument.head ||
        !frameDocument.head.querySelector('[data-emotion]')) return false;
    if (frameDocument.getElementById(styleId)) return true;

    var style = frameDocument.createElement('style');
    style.id = styleId;
    style.textContent = styleText;
    frameDocument.head.appendChild(style);
    return true;
  }

  function onChatOpen() {
    if (addStyle()) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (addStyle() || attempts >= 100) clearInterval(timer);
    }, 100);
  }

  var chatReady = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
      });

  chatReady.then(function () {
    window.GorgiasChat.on('widget:opened', onChatOpen);
    if (window.GorgiasChat.isOpen()) onChatOpen();
  });
})();
